
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.293 11.27c0 1.806 1.346 3.888 2.304 5.146H1.75a1.578 1.578 0 01-1.583-1.583V2.166c0-.87.705-1.583 1.583-1.583h.792v5.542l1.98-1.188L6.5 6.125V.583h4.75c.871 0 1.584.705 1.584 1.583v4.925a4.398 4.398 0 00-1.188-.175c-2.375 0-4.354 1.98-4.354 4.354zm7.125 0c0 2.059-2.77 5.146-2.77 5.146S8.875 13.33 8.875 11.27c0-1.504 1.267-2.77 2.771-2.77s2.771 1.266 2.771 2.77zm-1.82.08c0-.475-.476-.95-.95-.95-.476 0-.95.396-.95.95 0 .475.395.95.95.95.553 0 1.028-.475.95-.95z"}})])
          )
        }
      }
    